import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const steps = [
  {
    id: 1,
    title: 'Обнаружение спроса',
    description: 'Система мониторит 200 000+ Telegram-чатов, анализирует конкурентов и выявляет коммерческие запросы в реальном времени.',
    detail: 'Пока менеджеры ищут лидов вручную, AIGAM уже обработал сотни чатов и нашёл тех, кто прямо сейчас готов купить.',
  },
  {
    id: 2,
    title: 'Квалификация',
    description: 'Искусственный интеллект определяет намерение покупки и запускает персонализированный диалог с потенциальным клиентом.',
    detail: '98% точность определения коммерческого намерения. Система отличает праздный интерес от реальной готовности к сделке.',
  },
  {
    id: 3,
    title: 'Передача в CRM',
    description: 'Квалифицированный лид со всей историей диалога автоматически попадает в вашу CRM как готовая сделка.',
    detail: 'Интеграция с amoCRM, Bitrix24 и другими системами. Менеджер получает не холодный контакт, а готового к покупке клиента.',
  },
];

export default function FlowSection() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 150 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(3);

  return (
    <section id="how" className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16 max-w-2xl">
          <span
            ref={labelRef}
            className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
          >
            Процесс
          </span>
          <h2
            ref={titleRef}
            className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
          >
            Три шага от рыночного спроса до сделки в CRM
          </h2>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {steps.map((step, idx) => (
            <div
              key={step.id}
              className={`group relative rounded-2xl border border-background-200 bg-background-50 p-7 hover:border-foreground-950 hover:bg-background-950 transition-all duration-300 cursor-pointer overflow-hidden reveal-fade-up ${idx < cardsRevealed ? 'revealed' : ''}`}
              style={idx < cardsRevealed ? { transitionDelay: `${idx * 120}ms` } : undefined}
            >
              <div className="flex items-start justify-between">
                <span className="w-11 h-11 rounded-lg bg-primary-50 text-primary-500 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-arrow-right-line text-xl"></i>
                </span>
                <span className="font-display text-[36px] font-extrabold text-background-200 group-hover:text-background-50/15 transition-colors leading-none">
                  0{step.id}
                </span>
              </div>

              <h3 className="mt-6 font-display font-bold text-[20px] text-foreground-950 group-hover:text-background-50 transition-colors">
                {step.title}
              </h3>
              <p className="mt-2 text-[14.5px] text-foreground-500 group-hover:text-background-50/65 leading-relaxed transition-colors">
                {step.description}
              </p>
              <p className="mt-4 text-[13px] text-foreground-400 group-hover:text-background-50/50 leading-relaxed transition-colors pt-4 border-t border-background-200 group-hover:border-background-50/10">
                {step.detail}
              </p>

              <span className="absolute bottom-7 right-7 w-8 h-8 rounded-full bg-background-200 text-foreground-400 group-hover:bg-primary-500 group-hover:text-background-50 flex items-center justify-center transition-all">
                <i className="ri-arrow-right-up-line"></i>
              </span>
              {idx < 2 && (
                <span className="hidden lg:block absolute top-9 -right-2.5 w-5 h-px bg-background-200"></span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}